export default {
  data() {
    return {
      currentPage: Number(this.$route.query.page) || 1,
    };
  },
  created() {
    this.$watch(
      () => {
        if (!this.currentPage) this.currentPage = 1;

        // The element that include this mixin must define a getData() method,
        // in order to get the data when the page changed.
        this.getData();
      }
    );
  },
  methods: {
    getData(isNewSearch) {},
    pageCount(list) {
      if (list.length && list[0].counter)
        return Math.ceil(list[0].counter/10);
      return 1;
    }
  },
  watch: {
    currentPage: function (newCurrentPage, oldCurrentPage) {
      if (!newCurrentPage) this.currentPage = 1;
      const query = {};

      if (this.currentPage > 1) query.page = `${this.currentPage}`;
      // Sync to URI
      this.$router.push({ query: { ...this.$route.query, page: query.page, terms: this.terms } });
    },
    '$route.query.page': function(page) {
      if (typeof page == 'undefined')
        this.currentPage = 1;
    }
  }
};